import _slicedToArray from "/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classPrivateFieldInitSpec from "/app/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _classPrivateFieldSet from "/app/node_modules/@babel/runtime/helpers/esm/classPrivateFieldSet.js";
import _classPrivateFieldGet from "/app/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.typed-array.uint8-array.js";
import "core-js/modules/es.typed-array.at.js";
import "core-js/modules/es.typed-array.copy-within.js";
import "core-js/modules/es.typed-array.every.js";
import "core-js/modules/es.typed-array.fill.js";
import "core-js/modules/es.typed-array.filter.js";
import "core-js/modules/es.typed-array.find.js";
import "core-js/modules/es.typed-array.find-index.js";
import "core-js/modules/es.typed-array.for-each.js";
import "core-js/modules/es.typed-array.includes.js";
import "core-js/modules/es.typed-array.index-of.js";
import "core-js/modules/es.typed-array.iterator.js";
import "core-js/modules/es.typed-array.join.js";
import "core-js/modules/es.typed-array.last-index-of.js";
import "core-js/modules/es.typed-array.map.js";
import "core-js/modules/es.typed-array.reduce.js";
import "core-js/modules/es.typed-array.reduce-right.js";
import "core-js/modules/es.typed-array.reverse.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.slice.js";
import "core-js/modules/es.typed-array.some.js";
import "core-js/modules/es.typed-array.sort.js";
import "core-js/modules/es.typed-array.subarray.js";
import "core-js/modules/es.typed-array.to-locale-string.js";
import "core-js/modules/es.typed-array.to-string.js";
import "core-js/modules/es.array.fill.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.weak-map.js";
import "core-js/modules/web.dom-collections.iterator.js";
// Copyright 2017-2022 @polkadot/util-crypto authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { BN, bnToU8a, compactAddLength, hexToU8a, isBigInt, isBn, isHex, isNumber, isString, stringToU8a } from '@polkadot/util';
import { blake2AsU8a } from "../blake2/asU8a.js";
import { BN_LE_256_OPTS } from "../bn.js";
var RE_NUMBER = /^\d+$/;
var JUNCTION_ID_LEN = 32;

var _chainCode = /*#__PURE__*/new WeakMap();

var _isHard = /*#__PURE__*/new WeakMap();

export var DeriveJunction = /*#__PURE__*/function () {
  function DeriveJunction() {
    _classCallCheck(this, DeriveJunction);

    _classPrivateFieldInitSpec(this, _chainCode, {
      writable: true,
      value: new Uint8Array(32)
    });

    _classPrivateFieldInitSpec(this, _isHard, {
      writable: true,
      value: false
    });
  }

  _createClass(DeriveJunction, [{
    key: "chainCode",
    get: function get() {
      return _classPrivateFieldGet(this, _chainCode);
    }
  }, {
    key: "isHard",
    get: function get() {
      return _classPrivateFieldGet(this, _isHard);
    }
  }, {
    key: "isSoft",
    get: function get() {
      return !_classPrivateFieldGet(this, _isHard);
    }
  }, {
    key: "hard",
    value: function hard(value) {
      return this.soft(value).harden();
    }
  }, {
    key: "harden",
    value: function harden() {
      _classPrivateFieldSet(this, _isHard, true);

      return this;
    }
  }, {
    key: "soft",
    value: function soft(value) {
      if (isNumber(value) || isBn(value) || isBigInt(value)) {
        return this.soft(bnToU8a(value, BN_LE_256_OPTS));
      } else if (isHex(value)) {
        return this.soft(hexToU8a(value));
      } else if (isString(value)) {
        return this.soft(compactAddLength(stringToU8a(value)));
      } else if (value.length > JUNCTION_ID_LEN) {
        return this.soft(blake2AsU8a(value));
      }

      _classPrivateFieldGet(this, _chainCode).fill(0);

      _classPrivateFieldGet(this, _chainCode).set(value, 0);

      return this;
    }
  }, {
    key: "soften",
    value: function soften() {
      _classPrivateFieldSet(this, _isHard, false);

      return this;
    }
  }], [{
    key: "from",
    value: function from(value) {
      var result = new DeriveJunction();

      var _ref = value.startsWith('/') ? [value.substring(1), true] : [value, false],
          _ref2 = _slicedToArray(_ref, 2),
          code = _ref2[0],
          isHard = _ref2[1];

      result.soft(RE_NUMBER.test(code) ? new BN(code, 10) : code);
      return isHard ? result.harden() : result;
    }
  }]);

  return DeriveJunction;
}();